import { render, staticRenderFns } from "./CreatePackageModal.vue?vue&type=template&id=84543c22&scoped=true&"
import script from "./CreatePackageModal.vue?vue&type=script&lang=js&"
export * from "./CreatePackageModal.vue?vue&type=script&lang=js&"
import style0 from "./CreatePackageModal.vue?vue&type=style&index=0&id=84543c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84543c22",
  null
  
)

export default component.exports